module.exports = __webpack_public_path__ + "static/img/icon-add.383ded04.svg";